export const srcKeys = {
  key_esc: {
    style: {
      top: "0%",
      left: "0%",
      color: "#3c3a5b",
    },
  },
  key_f1: {
    style: {
      top: "0%",
      left: "8.1%",
      color: "#3696aa",
    },
  },
  key_f2: {
    style: {
      top: "0%",
      left: "14.4%",
      color: "#3696aa",
    },
  },
  key_f3: {
    style: {
      top: "0%",
      left: "20.9%",
      color: "#3696aa",
    },
  },
  key_f4: {
    style: {
      top: "0%",
      left: "27.3%",
      color: "#3696aa",
    },
  },
  key_f5: {
    style: {
      top: "0%",
      left: "35.3%",
      color: "#bc2b4c",
    },
  },
  key_f6: {
    style: {
      top: "0%",
      left: "41.7%",
      color: "#bc2b4c",
    },
  },
  key_f7: {
    style: {
      top: "0%",
      left: "48.1%",
      color: "#bc2b4c",
    },
  },
  key_f8: {
    style: {
      top: "0%",
      left: "54.5%",
      color: "#bc2b4c",
    },
  },
  key_f9: {
    style: {
      top: "0%",
      left: "62.5%",
      color: "#3696aa",
    },
  },
  key_f10: {
    style: {
      top: "0%",
      left: "68.9%",
      color: "#3696aa",
    },
  },
  key_f11: {
    style: {
      top: "0%",
      left: "75.3%",
      color: "#3696aa",
    },
  },
  key_f12: {
    style: {
      top: "0%",
      left: "81.7%",
      color: "#3696aa",
    },
  },
  key_delete: {
    style: {
      top: "0%",
      left: "89.6%",
      color: "#bc2b4c",
    },
  },
  key_home: {
    style: {
      top: "0%",
      left: "96%",
      color: "#bc2b4c",
    },
  },
  key_GAT: {
    style: {
      top: "21%",
      left: "0%",
      color: "#bc2b4c",
    },
  },
  key_1: {
    style: {
      top: "21%",
      left: "6.4%",
      color: "#3696aa",
    },
  },
  key_2: {
    style: {
      top: "21%",
      left: "12.8%",
      color: "#3696aa",
    },
  },
  key_3: {
    style: {
      top: "21%",
      left: "19.2%",
      color: "#3696aa",
    },
  },
  key_4: {
    style: {
      top: "21%",
      left: "25.6%",
      color: "#3696aa",
    },
  },
  key_5: {
    style: {
      top: "21%",
      left: "32.1%",
      color: "#3696aa",
    },
  },
  key_6: {
    style: {
      top: "21%",
      left: "38.4%",
      color: "#3696aa",
    },
  },
  key_7: {
    style: {
      top: "21%",
      left: "44.8%",
      color: "#3696aa",
    },
  },
  key_8: {
    style: {
      top: "21%",
      left: "51.1%",
      color: "#3696aa",
    },
  },
  key_9: {
    style: {
      top: "21%",
      left: "57.6%",
      color: "#3696aa",
    },
  },
  key_0: {
    style: {
      top: "21%",
      left: "64%",
      color: "#3696aa",
    },
  },
  key_mis: {
    style: {
      top: "21%",
      left: "70.4%",
      color: "#3696aa",
    },
  },
  key_equ: {
    style: {
      top: "21%",
      left: "76.8%",
      color: "#3696aa",
    },
  },
  key_backspace: {
    style: {
      width: "10%",
      top: "21%",
      left: "83.2%",
      color: "#bc2b4c",
      paddingLeft: "2%",
    },
  },
  key_end: {
    style: {
      top: "21%",
      left: "96%",
      color: "#bc2b4c",
    },
  },
  key_tab: {
    style: {
      width: "7%",
      top: "37.3%",
      left: "0%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_q: {
    style: {
      top: "37.3%",
      left: "9.7%",
      color: "#3696aa",
    },
  },
  key_w: {
    style: {
      top: "37.3%",
      left: "16%",
      color: "#3696aa",
    },
  },
  key_e: {
    style: {
      top: "37.3%",
      left: "22.4%",
      color: "#3696aa",
    },
  },
  key_r: {
    style: {
      top: "37.3%",
      left: "28.9%",
      color: "#3696aa",
    },
  },
  key_t: {
    style: {
      top: "37.3%",
      left: "35.3%",
      color: "#3696aa",
    },
  },
  key_y: {
    style: {
      top: "37.3%",
      left: "41.6%",
      color: "#3696aa",
    },
  },
  key_u: {
    style: {
      top: "37.3%",
      left: "48%",
      color: "#3696aa",
    },
  },
  key_i: {
    style: {
      top: "37.3%",
      left: "54.4%",
      color: "#3696aa",
    },
  },
  key_o: {
    style: {
      top: "37.3%",
      left: "60.8%",
      color: "#3696aa",
    },
  },
  key_p: {
    style: {
      top: "37.3%",
      left: "67.2%",
      color: "#3696aa",
    },
  },
  key_oqo: {
    style: {
      top: "37.3%",
      left: "73.6%",
      color: "#3696aa",
    },
  },
  key_eqo: {
    style: {
      top: "37.3%",
      left: "80%",
      color: "#3696aa",
    },
  },
  key_bsl: {
    style: {
      width: "7%",
      top: "37.3%",
      left: "86.4%",
      color: "#3696aa",
    },
  },
  key_pgup: {
    style: {
      top: "37.3%",
      left: "96%",
      color: "#bc2b4c",
    },
  },
  key_cap: {
    style: {
      width: "8.8%",
      top: "54%",
      left: "0%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_a: {
    style: {
      top: "54%",
      left: "11.3%",
      color: "#3696aa",
    },
  },
  key_s: {
    style: {
      top: "54%",
      left: "17.7%",
      color: "#3696aa",
    },
  },
  key_d: {
    style: {
      top: "54%",
      left: "24.1%",
      color: "#3696aa",
    },
  },
  key_f: {
    style: {
      top: "54%",
      left: "30.4%",
      color: "#3696aa",
    },
  },
  key_g: {
    style: {
      top: "54%",
      left: "36.8%",
      color: "#3696aa",
    },
  },
  key_h: {
    style: {
      top: "54%",
      left: "43.1%",
      color: "#3696aa",
    },
  },
  key_j: {
    style: {
      top: "54%",
      left: "49.5%",
      color: "#3696aa",
    },
  },
  key_k: {
    style: {
      top: "54%",
      left: "55.9%",
      color: "#3696aa",
    },
  },
  key_l: {
    style: {
      top: "54%",
      left: "62.2%",
      color: "#3696aa",
    },
  },
  key_COL: {
    style: {
      top: "54%",
      left: "68.6%",
      color: "#3696aa",
    },
  },
  key_CC: {
    style: {
      top: "54%",
      left: "75.1%",
      color: "#3696aa",
    },
  },
  key_enter: {
    style: {
      width: "12%",
      top: "54%",
      left: "81.5%",
      color: "#3c3a5b",
      paddingLeft: "3%",
    },
  },
  key_pgdn: {
    style: {
      top: "54%",
      left: "96%",
      color: "#bc2b4c",
    },
  },
  key_shift_l: {
    style: {
      width: "12%",
      top: "71%",
      left: "0%",
      color: "#bc2b4c",
      paddingLeft: "2.8%",
    },
  },
  key_z: {
    style: {
      top: "71%",
      left: "14.6%",
      color: "#3696aa",
    },
  },
  key_x: {
    style: {
      top: "71%",
      left: "20.9%",
      color: "#3696aa",
    },
  },
  key_c: {
    style: {
      top: "71%",
      left: "27.3%",
      color: "#3696aa",
    },
  },
  key_v: {
    style: {
      top: "71%",
      left: "33.7%",
      color: "#3696aa",
    },
  },
  key_b: {
    style: {
      top: "71%",
      left: "40%",
      color: "#3696aa",
    },
  },
  key_n: {
    style: {
      top: "71%",
      left: "46.4%",
      color: "#3696aa",
    },
  },
  key_m: {
    style: {
      top: "71%",
      left: "52.7%",
      color: "#3696aa",
    },
  },
  key_CMA: {
    style: {
      top: "71%",
      left: "59.1%",
      color: "#3696aa",
    },
  },
  key_DOT: {
    style: {
      top: "71%",
      left: "65.5%",
      color: "#3696aa",
    },
  },
  key_SL: {
    style: {
      top: "71%",
      left: "71.9%",
      color: "#3696aa",
    },
  },
  key_shift_r: {
    style: {
      width: "8.8%",
      top: "71%",
      left: "78.3%",
      color: "#bc2b4c",
      paddingLeft: "2.8%",
    },
  },
  key_up: {
    style: {
      top: "71%",
      left: "89.6%",
      color: "#bc2b4c",
    },
  },
  key_ctrl_l: {
    style: {
      width: "5.7%",
      top: "87.5%",
      left: "0%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_win_l: {
    style: {
      width: "5.7%",
      top: "87.5%",
      left: "8.1%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_alt_l: {
    style: {
      width: "5.7%",
      top: "87.5%",
      left: "16.1%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_space: {
    style: {
      width: "37.2%",
      top: "87.5%",
      left: "24.2%",
      color: "#3696aa",
      paddingLeft: "2%",
    },
  },
  KEY_FN: {
    style: {
      width: "5.7%",
      top: "87.5%",
      left: "64%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
    disabled: false, //
  },
  key_ctrl_r: {
    style: {
      width: "5.7%",
      top: "87.5%",
      left: "72%",
      color: "#bc2b4c",
      paddingLeft: "0.5%",
    },
  },
  key_left: {
    style: {
      top: "87.5%",
      left: "83.2%",
      color: "#bc2b4c",
    },
  },
  key_down: {
    style: {
      top: "87.5%",
      left: "89.5%",
      color: "#bc2b4c",
    },
  },
  key_right: {
    style: {
      top: "87.5%",
      left: "96%",
      color: "#bc2b4c",
    },
  },
};

export const dstKeys = {
  key_esc: [
    {
      text: "Esc",
      style: {
        top: "50%",
      },
    },
  ],
  key_f1: [
    {
      text: "F1",
      style: {
        top: "50%",
      },
    },
  ],
  key_f2: [
    {
      text: "F2",
      style: {
        top: "50%",
      },
    },
  ],
  key_f3: [
    {
      text: "F3",
      style: {
        top: "50%",
      },
    },
  ],
  key_f4: [
    {
      text: "F4",
      style: {
        top: "50%",
      },
    },
  ],
  key_f5: [
    {
      text: "F5",
      style: {
        top: "50%",
      },
    },
  ],
  key_f6: [
    {
      text: "F6",
      style: {
        top: "50%",
      },
    },
  ],
  key_f7: [
    {
      text: "F7",
      style: {
        top: "50%",
      },
    },
  ],
  key_f8: [
    {
      text: "F8",
      style: {
        top: "50%",
      },
    },
  ],
  key_f9: [
    {
      text: "F9",
      style: {
        top: "50%",
      },
    },
  ],
  key_f10: [
    {
      text: "F10",
      style: {
        top: "50%",
      },
    },
  ],
  key_f11: [
    {
      text: "F11",
      style: {
        top: "50%",
      },
    },
  ],
  key_f12: [
    {
      text: "F12",
      style: {
        top: "50%",
      },
    },
  ],
  key_delete: [
    {
      text: "Delete",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_home: [
    {
      text: "Home",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_GAT: [
    {
      text: "~",
      style: {
        top: "30%",
        fontSize: "1.7em",
      },
    },
    {
      text: "`",
      style: {
        top: "90%",
        fontSize: "1.7em",
      },
    },
  ],
  key_1: [
    {
      text: "!",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "1",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_2: [
    {
      text: "@",
      style: {
        top: "25%",
        fontSize: "1.2em",
      },
    },
    {
      text: "2",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_3: [
    {
      text: "#",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "3",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_4: [
    {
      text: "$",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "4",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_5: [
    {
      text: "%",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "5",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_6: [
    {
      text: "^",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "6",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_7: [
    {
      text: "&",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "7",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_8: [
    {
      text: "*",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "8",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_9: [
    {
      text: "(",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "9",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_0: [
    {
      text: ")",
      style: {
        top: "30%",
        fontSize: "1.2em",
      },
    },
    {
      text: "0",
      style: {
        top: "70%",
        fontSize: "1.2em",
      },
    },
  ],
  key_mis: [
    {
      text: "_",
      style: {
        top: "15%",
        fontSize: "1.4em",
      },
    },
    {
      text: "-",
      style: {
        top: "60%",
        fontSize: "1.4em",
      },
    },
  ],
  key_equ: [
    {
      text: "+",
      style: {
        top: "30%",
        fontSize: "1.4em",
      },
    },
    {
      text: "=",
      style: {
        top: "65%",
        fontSize: "1.4em",
      },
    },
  ],
  key_backspace: [
    {
      text: "Backspace",
      style: {
        top: "50%",
        fontSize: "0.65em",
      },
    },
  ],
  key_end: [
    {
      text: "End",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_tab: [
    {
      text: "Tab",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_q: [
    {
      text: "Q",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_w: [
    {
      text: "W",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_e: [
    {
      text: "E",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_r: [
    {
      text: "R",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_t: [
    {
      text: "T",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_y: [
    {
      text: "Y",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_u: [
    {
      text: "U",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_i: [
    {
      text: "I",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_o: [
    {
      text: "O",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_p: [
    {
      text: "P",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_oqo: [
    {
      text: "{",
      style: {
        top: "25%",
        fontSize: "1.3em",
      },
    },
    {
      text: "[",
      style: {
        top: "70%",
        fontSize: "1.3em",
      },
    },
  ],
  key_eqo: [
    {
      text: "}",
      style: {
        top: "25%",
        fontSize: "1.3em",
      },
    },
    {
      text: "]",
      style: {
        top: "70%",
        fontSize: "1.3em",
      },
    },
  ],
  key_bsl: [
    {
      text: "|",
      style: {
        top: "25%",
        fontSize: "1.3em",
      },
    },
    {
      text: "\\",
      style: {
        top: "70%",
        fontSize: "1.3em",
      },
    },
  ],
  key_pgup: [
    {
      text: "Pg Up",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cap: [
    {
      text: "CapsLock",
      style: {
        top: "50%",
        fontSize: "0.7em",
      },
    },
  ],
  key_a: [
    {
      text: "A",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_s: [
    {
      text: "S",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_d: [
    {
      text: "D",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_f: [
    {
      text: "F",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_g: [
    {
      text: "G",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_h: [
    {
      text: "H",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_j: [
    {
      text: "J",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_k: [
    {
      text: "K",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_l: [
    {
      text: "L",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_COL: [
    {
      text: ":",
      style: {
        top: "25%",
        fontSize: "1.4em",
      },
    },
    {
      text: ";",
      style: {
        top: "65%",
        fontSize: "1.4em",
      },
    },
  ],
  key_CC: [
    {
      text: '"',
      style: {
        top: "30%",
        fontSize: "1.4em",
      },
    },
    {
      text: "'",
      style: {
        top: "75%",
        fontSize: "1.4em",
      },
    },
  ],
  key_enter: [
    {
      text: "Enter",
      style: {
        top: "50%",
      },
    },
  ],
  key_pgdn: [
    {
      text: "Pg Dn",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_shift_l: [
    {
      text: "Shift",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_z: [
    {
      text: "Z",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_x: [
    {
      text: "X",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_c: [
    {
      text: "C",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_v: [
    {
      text: "V",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_b: [
    {
      text: "B",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_n: [
    {
      text: "N",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_m: [
    {
      text: "M",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_CMA: [
    {
      text: "<",
      style: {
        top: "25%",
        fontSize: "1.8em",
      },
    },
    {
      text: ",",
      style: {
        top: "60%",
        fontSize: "1.3em",
      },
    },
  ],
  key_DOT: [
    {
      text: ">",
      style: {
        top: "25%",
        fontSize: "1.8em",
      },
    },
    {
      text: ".",
      style: {
        top: "60%",
        fontSize: "1.3em",
      },
    },
  ],
  key_SL: [
    {
      text: "?",
      style: {
        top: "25%",
        fontSize: "1.5em",
      },
    },
    {
      text: "/",
      style: {
        top: "70%",
        fontSize: "1.4em",
      },
    },
  ],
  key_shift_r: [
    {
      text: "Shift",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_up: [
    {
      text: "↑",
      style: {
        top: "25%",
        fontSize: "1.7em",
      },
    },
  ],
  key_ctrl_l: [
    {
      text: "Control",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_win_l: [
    {
      text: "Code",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_alt_l: [
    {
      text: "Alt",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_space: [
    {
      text: "Space",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_app: [
    {
      text: "Menu",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_ctrl_r: [
    {
      text: "Control",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_left: [
    {
      text: "←",
      style: {
        top: "25%",
        fontSize: "1.7em",
      },
    },
  ],
  key_down: [
    {
      text: "↓",
      style: {
        top: "25%",
        fontSize: "1.7em",
      },
    },
  ],
  key_right: [
    {
      text: "→",
      style: {
        top: "25%",
        fontSize: "1.7em",
      },
    },
  ],
  key_alt_r: [
    {
      text: "Alt",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_win_r: [
    {
      text: "Code",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_print: [
    {
      text: "Print",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_scroll: [
    {
      text: "ScrLock",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_pause: [
    {
      text: "Pause",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_insert: [
    {
      text: "Insert",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_play_h: [
    {
      text: "Play/Pause",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_mute_h: [
    {
      text: "Mute",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_vol_dec_h: [
    {
      text: "VolDn",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_vol_add_h: [
    {
      text: "VolUp",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_numlock: [
    {
      text: "NumLock",
      style: {
        top: "50%",
        fontSize: "0.7em",
      },
    },
  ],
  key_num_PADNSL: [
    {
      text: "/",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_PADNMU: [
    {
      text: "*",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_PADNMI: [
    {
      text: "-",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_7: [
    {
      text: "7",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_8: [
    {
      text: "8",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_9: [
    {
      text: "9",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_PADNPL: [
    {
      text: "+",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_4: [
    {
      text: "4",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_5: [
    {
      text: "5",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_6: [
    {
      text: "6",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_1: [
    {
      text: "1",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_2: [
    {
      text: "2",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_3: [
    {
      text: "3",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_0: [
    {
      text: "0",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_del: [
    {
      text: ".",
      style: {
        top: "23%",
        fontSize: "1.7em",
      },
    },
  ],
  key_num_enter: [
    {
      text: "Enter",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_local_key_fun_switch_left: [
    {
      text: "FnS",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_on_off_led: [
    {
      text: "LED On/Off",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_next_page: [
    {
      text: "Next LED",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_lightness_add: [
    {
      text: "LED Light+",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_lightness_reduce: [
    {
      text: "LED Light-",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_speed_add: [
    {
      text: "LED Speed+",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_speed_reduce: [
    {
      text: "LED Speed-",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_local_key_mode_cmd_on_off: [
    {
      text: "PCB On/Off",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_local_key_next_mode: [
    {
      text: "Next PCB",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_local_key_mode_lightness_add: [
    {
      text: "PCB Light+",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_local_key_mode_lightness_reduce: [
    {
      text: "PCB Light-",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_ble_shfit1: [
    {
      text: "BT_1",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_ble_shfit2: [
    {
      text: "BT_2",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_ble_shfit3: [
    {
      text: "BT_3",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_ble_2_4g: [
    {
      text: "2.4G",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer1: [
    {
      text: "Layer1",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer2: [
    {
      text: "Layer2",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer3: [
    {
      text: "Layer3",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer4: [
    {
      text: "Layer4",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer5: [
    {
      text: "Layer5",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer6: [
    {
      text: "Layer6",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_cmd_set_key_layer7: [
    {
      text: "Layer7",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer1: [
    {
      text: "Fn1",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  KEY_FN: [
    {
      text: "Fn2",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer3: [
    {
      text: "Fn3",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer4: [
    {
      text: "Fn4",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer5: [
    {
      text: "Fn5",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer6: [
    {
      text: "Fn6",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_hold_set_key_layer7: [
    {
      text: "Fn7",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_led_cmd_factory_reset: [
    {
      text: "Reset",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_mute: [
    {
      text: "Mute",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_volume_up: [
    {
      text: "VolUp",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_volume_down: [
    {
      text: "VolDn",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_prev_track: [
    {
      text: "|◀",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_next_track: [
    {
      text: "▶|",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
  key_media_play_pause: [
    {
      text: "▶ / ‖",
      style: {
        top: "50%",
        fontSize: "0.9em",
      },
    },
  ],
};
